import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Support.css";
import search from "../../assets/images/searchi.svg";
import { Routers } from "../../routes/Constant";
import learner from "../../assets/images/learner-support.svg";
import instructor from "../../assets/images/instructor-support.svg";
import { useDispatch, useSelector } from "react-redux";
import { supportTranning } from "../../redux/slice/InstructorSlice";

const Support = () => {
  const [searchTerm, setSearchTerm] = useState(""); // State for search input
  const [filteredArticles, setFilteredArticles] = useState([]); // State for filtered articles

  const supportCards = [
    { href: "/xcsfvt/support-content/learner", title: "Learner", description: "Information & support for learner drivers", img: learner },
    { href: "/xcsfvt/support-content/instructor", title: "Driving Instructors", description: "Information & support for driving instructors", img: instructor },
  ];

  const promotedArticles = [
    { href: Routers.supportDetails, title: "Payment Options" },
    { href: Routers.supportDetails, title: "How many driving lessons do I need?" },
    { href: Routers.supportDetails, title: "How to change your driving instructor" },
    { href: Routers.supportDetails, title: "How to cancel a booking with your instructor" },
    { href: Routers.supportDetails, title: "How to request a late cancellation with your instructor (Less than 24 hrs)" },
    { href: Routers.supportDetails, title: "How to view your booking credits" },
  ];

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(supportTranning("learner"));
    dispatch(supportTranning("instructor"));
  }, [dispatch]);

  const response = useSelector((state) => state?.instructors?.tranning);
  const articles = response?.[0] || promotedArticles;

  // Filtering the articles based on the search term
  useEffect(() => {
    if (searchTerm) {
      const filtered = articles.filter((article) =>
        article.title.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredArticles(filtered);
    } else {
      setFilteredArticles("");
    }
  }, [searchTerm, articles]);

  return (
    <section className="keyzi_support--wrapper">
      <div className="container">
        <div className="keyzi_support--inner">
          <div className="support-head">
            <h2>How can we help?</h2>
            <div className="search-wrapper">
              <img src={search} alt="search" />
              <input
                type="search"
                className="form-control"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {filteredArticles.length > 0 ? (
  <ul className="article-list-wrapper">
    {filteredArticles.map((article, index) => {
      const title = article?.title || '';
      const regex = new RegExp(`(${searchTerm})`, 'gi'); // Regular expression to match search term
      const parts = title.split(regex); // Split the title at the match

      return (
        <li key={index}>
          <Link to={`/xcsfvt/support-content/learner/${article?.id || index}`} className="text-capitalize">
            {parts.map((part, idx) =>
              // If part matches searchTerm, wrap it with <strong> to make it bold
              part.toLowerCase() === searchTerm.toLowerCase() ? (
                <strong key={idx}>{part}</strong>
              ) : (
                part
              )
            )}
          </Link>
        </li>
      );
    })}
  </ul>
) : (
  ""
)}
            </div>
          </div>
          <div className="support-body">
            {supportCards.map((card, index) => (
              <Link to={card.href} key={index}>
                <div className="support-card">
                  <div className="card-img">
                    <img src={card.img} className="img-fluid" alt={card.title} />
                  </div>
                  <div className="rs-contnet">
                    <h4>{card.title}</h4>
                    <p>{card.description}</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
          <div className="support-bottom">
            <h3>Promoted articles</h3>
            {articles.length > 0 ? (
              <ul className="search-dropdown">
                {articles.map((article, index) => (
                  <li key={index}>
                    <Link to={`/xcsfvt/support-content/learner/${article?.id || index}`} className="text-capitalize">
                      {article?.title}
                    </Link>
                  </li>
                ))}
              </ul>
            ) : (
              <h2 className="text-center text-muted mt-5">No Article Found</h2>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Support;
